<template>
  <div>
    <h1>2FA Settings</h1>
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>